var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditorNoteEdit = function SvgAuditorNoteEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.444 5.667.888.887-8.575 8.557H1.89v-.869l8.555-8.575ZM13.844 0a.945.945 0 0 0-.661.274l-1.729 1.728 3.542 3.542 1.728-1.728c.368-.369.368-.983 0-1.332l-2.21-2.21a.927.927 0 0 0-.67-.274Zm-3.4 3.013L0 13.458V17h3.541L13.985 6.554l-3.54-3.541Z",
    fill: "#65A254"
  })));
};
export default SvgAuditorNoteEdit;